var SECONDARY_BORDER_RADIUS = {
  small: '0',
  medium: '0',
  large: '0'
};

export { SECONDARY_BORDER_RADIUS as default };
